module.exports = __webpack_public_path__ + "static/img/seuart.5014cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seuart.png
// module id = etJw
// module chunks = 1